// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import { BillingFieldsFragment, CreditCardFieldsFragment, BillingPlanFieldsFragment, PermissionsForOrganizationFragment } from '../../organization/fragments.generated';
import gql from 'graphql-tag';
import { BillingFieldsFragmentDoc, CreditCardFieldsFragmentDoc, BillingPlanFieldsFragmentDoc, PermissionsForOrganizationFragmentDoc } from '../../organization/fragments.generated';
import { useApolloFragment } from 'apollo-fragment-react';


export type OrganizationPlanFieldsFragment = (
  { __typename?: 'Organization' }
  & Pick<Types.Organization, 'id' | 'name'>
  & { billing?: Types.Maybe<(
    { __typename?: 'BillingInformation' }
    & { creditCard?: Types.Maybe<(
      { __typename?: 'CreditCard' }
      & CreditCardFieldsFragment
    )>, plan?: Types.Maybe<(
      { __typename?: 'SubscriptionPlan' }
      & BillingPlanFieldsFragment
    )> }
    & BillingFieldsFragment
  )>, rteSummary?: Types.Maybe<(
    { __typename?: 'RealTimeEditSummary' }
    & Pick<Types.RealTimeEditSummary, 'id' | 'RTEsInCurrentDay' | 'RTEsInCurrentPeriod' | 'limit'>
  )> }
);

export const OrganizationPlanFieldsFragmentDoc = gql`
    fragment organizationPlanFields on Organization {
  id
  name
  billing {
    ...billingFields
    creditCard {
      ...creditCardFields
    }
    plan {
      ...billingPlanFields
    }
  }
  rteSummary {
    id
    RTEsInCurrentDay
    RTEsInCurrentPeriod
    limit
  }
}
    ${BillingFieldsFragmentDoc}
${CreditCardFieldsFragmentDoc}
${BillingPlanFieldsFragmentDoc}`;

  /**
   * __useOrganizationPlanFieldsFragment__
   * To read a fragment data from Apollo Cache, call `useOrganizationPlanFieldsFragment` and pass it the ID of the cached object.
   * When your component renders, `useOrganizationPlanFieldsFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useOrganizationPlanFieldsFragment('fragment-id');
   */
export function useOrganizationPlanFieldsFragment(id: string) {
          return useApolloFragment<OrganizationPlanFieldsFragment>(OrganizationPlanFieldsFragmentDoc, id);
        }
export type OrganizationPlanFieldsFragmentHookResult = ReturnType<typeof useOrganizationPlanFieldsFragment>;